import React from 'react';

import './mobile-side-bar.styles.scss';

interface SidebarProps {
  children?: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

const MobileSidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  return (
    <div className={`mobileSidebar ${isOpen ? 'open' : ''}`}>
      <button onClick={onClose} className="closeButton">
        X
      </button>
      <div className="mobileSidebarContent">{children}</div>
    </div>
  );
};

export default MobileSidebar;
